import React, { Fragment, PureComponent } from 'react';
import { Input, Tabs, Button } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'dva';
import router from 'umi/router';
import styles from './index.less';

import { nl2br, groupBy } from '../../utils/utils';
import SingleSignatureRemediationSteps from './components/SingleSignatureRemediationSteps';
import SingleSignatureHeader from './components/SingleSignatureHeader';
import SingleSignatureDetail from './components/SingleSignatureDetail';
import SingleSignatureTabs from './components/SingleSignatureTabs';
import SignatureDrawerSkeleton from './components/skeletons/signatureDrawerSkeleton';
import { getHistoricalDate } from '../../utils/getHistoricalDate';
import UniversalDrawer from './Index';
import { CNS_CATEGORIES } from '@/models/universalDrawer';
import Exception from '@/components/Exception';
import Link from 'umi/link';
import GraphComponent from './components/graph';
import CustomSignatureDetail from './components/customsignaturedetail';
const { TabPane } = Tabs;
const { Search } = Input;
@connect(({ cloudAccount, organisation, universalDrawer, resourcesReport, user, global }) => ({
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
  selectedCloudAccounts: cloudAccount.selectedCloudAccounts,
  organisation: organisation.current,
  filteredResourcesOfSingleRisk: universalDrawer.filteredResourcesOfSingleRisk,
  resourcesReport: resourcesReport.report,
  appliedFilters: universalDrawer.appliedFilters,
  currentRiskData: universalDrawer.currentRiskData,
  selectedDate: universalDrawer.selectedDate,
  currentSignatureMetaData: universalDrawer.currentSignatureMetaData,
  currentUser: user.currentUser,
  spRisks: organisation.spRisks,
  alertCloudAcc: universalDrawer.alertCloudAcc,
  drawerLoading: universalDrawer.loading,
  enableDelay: universalDrawer.enableDelay,
  globalCategories: global.globalCategories,
}))
class SignatureDrawer extends PureComponent {
  state = { activeTab: '1' };

  componentDidMount() {
    const {
      dispatch,
      selectedCloudAccounts,
      organisation,
      alertCloudAcc,
      resourcesReport,
    } = this.props;

    // dispatch({
    //   type: 'resourcesReport/getReport',
    //   payload: {
    //     orgId: organisation.id,
    //     cloudAccounts:
    //       alertCloudAcc.length > 0 ? alertCloudAcc : selectedCloudAccounts.map(v => v.id),
    //   },
    // });

    dispatch({
      type: 'universalDrawer/getResourcesOfSingleRisk',
    });

    // this.props.selectedCloudAccounts.map(each => {
    //   console.log('CMD');
    //   dispatch({
    //     type: 'universalDrawer/getResourcesOfSingleRisk',
    //     payload: {
    //       cloudAccountId: each.id,
    //     },
    //   });
    // });
  }
  componentDidUpdate(prevProps) {
    const { dispatch, resourcesReport, selectedCloudAccounts, enableDelay } = this.props;

    if (JSON.stringify(prevProps.appliedFilters) !== JSON.stringify(this.props.appliedFilters)) {
      this.props.selectedCloudAccounts.map(each => {
        dispatch({
          type: 'universalDrawer/getResourcesOfSingleRisk',
          payload: {
            cloudAccountId: each.id,
          },
        });
      });
    }
    if (prevProps.selectedCloudAccounts.length !== this.props.selectedCloudAccounts.length) {
      this.props.selectedCloudAccounts.map(each => {
        dispatch({
          type: 'universalDrawer/getResourcesOfSingleRisk',
          payload: {
            cloudAccountId: each.id,
          },
        });
      });
    }
    if (prevProps.spRisks !== this.props.spRisks) {
      this.props.selectedCloudAccounts.map(each => {
        dispatch({
          type: 'universalDrawer/getResourcesOfSingleRisk',
          payload: {
            cloudAccountId: each.id,
          },
        });
      });
    }
  }
  componentWillUnmount() {
    const { dispatch } = this.props;
    // to clear data completely from the universal drawer model
    dispatch({
      type: 'universalDrawer/clear',
    });
  }

  changeTab = activeKey => {
    this.setState({
      activeTab: activeKey,
    });
  };

  handleHistoryChange = e => {
    let { appliedFilters, dispatch } = this.props;

    dispatch({
      type: 'universalDrawer/saveSelectedDate',
      payload: {
        selectedDate: e,
      },
    });

    appliedFilters = appliedFilters.filter(v => v.type !== 'history');

    if (e) {
      let date = getHistoricalDate(e);
      let historyFilter = {
        type: 'history',
        value: [date.endTime],
      };
      appliedFilters.push(historyFilter);
    }

    this.applyFilter(appliedFilters);
  };

  applyFilter = rules => {
    let rulesStringify = JSON.stringify(rules);
    const url = window.location.search;
    let modifiedUrl = url.replace(/(filters=)[^\&]+/, `$1${rulesStringify}`);
    router.push(modifiedUrl);
  };

  render() {
    let {
      allCloudAccountsList,
      selectedCloudAccounts,
      metadata,
      organisation,
      customSigMetaData,
      filteredResourcesOfSingleRisk,
      resourcesReport,
      currentSignatureMetaData,
      drawerLoading,
      selectedDate,
      appliedFilters,
      currentRiskData,
      globalCategories,
      alertCloudAcc,
    } = this.props;

    if (this.props.currentRiskData.signatureType === 'cartography') {
      return (
        <div>
          <CustomSignatureDetail data={this.props.currentRiskData} />

          {this.props.currentRiskData?.result?.nodes?.length > 0 &&
          this.props.currentRiskData?.result?.edges?.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
              <GraphComponent
                nodesData={this.props.currentRiskData.result.nodes}
                edgesData={this.props.currentRiskData.result.edges}
              />
              <SingleSignatureRemediationSteps
                remediationSteps={this.props.currentRiskData.RemediationSteps}
              />
            </div>
          ) : (
            <div
              style={{
                marginTop: '8rem',
                textAlign: 'center',
                color: 'grey',
              }}
            >
              No graph data found for this signature
            </div>
          )}

          {/* <SingleSignatureTabs {...singleSignatureTabsProps} /> */}
        </div>
      );
    }

    if (drawerLoading) return <SignatureDrawerSkeleton />;
    if (!currentSignatureMetaData) {
      const refreshPage = () => {
        window.location.reload(); // This reloads the entire page
      };

      return (
        <div style={{ position: 'relative', minHeight: '100vh' }}>
          {/* Refresh Button */}
          <Button
            type="primary"
            onClick={refreshPage} // Reload the page on click
            style={{
              position: 'fixed',
              top: '20px',
              right: '20px',
              zIndex: 1000,
            }}
          >
            Refresh Page
          </Button>

          {/* Exception Component */}
          <Exception
            style={{ marginTop: '10rem' }}
            type="500"
            title="OOPS!"
            backText="See Dashboard"
            desc="Data malformed or not found"
            linkElement={Link}
          />
        </div>
      );
    }

    let signatureHeaderProps;
    let singleSignatureDetailProps;
    let singleSignatureTabsProps;
    let currentSigCloudAccounts;

    if (!_.isEmpty(currentSignatureMetaData)) {
      let currentSig = currentSignatureMetaData?.name;

      if (_.isEmpty(alertCloudAcc)) {
        currentSigCloudAccounts = allCloudAccountsList.filter(
          c => c.provider.toLowerCase() === currentSignatureMetaData.cloud.toLowerCase()
        );
      } else {
        currentSigCloudAccounts = allCloudAccountsList.filter(c => alertCloudAcc.includes(c.id));
      }

      appliedFilters = appliedFilters.filter(v => v.type === 'signatureName');

      filteredResourcesOfSingleRisk = filteredResourcesOfSingleRisk?.map(val => {
        let riskStatusMessage;
        let suppressResource = false;
        if (val.risks.length > 0) {
          val.risks.map(item => {
            if (item.suppress === true) {
              suppressResource = true;
            } else {
              suppressResource = false;
            }
          });
        }

        if (val.signatures) {
          riskStatusMessage = val.signatures[currentSig]?.statusMessage;
        }
        val.statusMessage = riskStatusMessage;
        val.suppress = suppressResource;
        return val;
      });

      const signatureStatus = filteredResourcesOfSingleRisk?.some(val => val.status === 'fail')
        ? 'fail'
        : 'pass';

      signatureHeaderProps = {
        selectedDate,
        signatureName: currentSignatureMetaData?.name,
        pageDetail: currentSignatureMetaData?.pageDetail,
        description: currentSignatureMetaData?.description,
        handleHistoryChange: this.handleHistoryChange,
        riskType: currentSignatureMetaData?.riskType || '',
        dataSource: currentSignatureMetaData?.dataSource || '',
      };
      singleSignatureDetailProps = {
        globalCategories,
        status: signatureStatus,
        filteredResourcesOfSingleRisk,
        cloudAccounts: currentSigCloudAccounts,
        riskLevel: currentSignatureMetaData?.risk,
        category: currentSignatureMetaData?.category,
        cvssScore: currentSignatureMetaData?.cvssScore,
        cvss3Severity: currentSignatureMetaData?.cvss3Severity,
        AffectedPackages: currentSignatureMetaData?.AffectedPackages,
        cvssVector: currentSignatureMetaData?.cvssVector,
        signatureName:
          currentSignatureMetaData?.title ||
          currentSignatureMetaData?.messageFail ||
          currentSignatureMetaData?.description ||
          '',
        riskType: currentSignatureMetaData?.riskType || '',
        service:
          currentSignatureMetaData?.riskType === 'thirdPartyRisks'
            ? filteredResourcesOfSingleRisk?.[0] && filteredResourcesOfSingleRisk?.[0].service
              ? filteredResourcesOfSingleRisk?.[0].service
              : ''
            : currentSignatureMetaData?.service,
        _cveId: currentSignatureMetaData._cveId,
      };
      singleSignatureTabsProps = {
        remediationSteps: currentSignatureMetaData?.RemediationSteps,
        onChange: this.changeTab,
        activeTab: this.state.activeTab,
        allCloudAccountsList,
        selectedCloudAccounts,
        organisation,
        currentUser: this.props.currentUser,
        drawerLoading,
        description: currentSignatureMetaData?.description || '',
        dataSource: currentSignatureMetaData?.dataSource || '',
        signatureName:
          currentSignatureMetaData?.signatureName || currentSignatureMetaData?.description || '',
        cloudAccounts: currentSigCloudAccounts,
        service: currentSignatureMetaData?.service || '',
        riskType: currentSignatureMetaData?.riskType || '',
      };

      // * Adding Failed and passed reosurces in props if the current signatures has any risks
      if (!_.isEmpty(filteredResourcesOfSingleRisk)) {
        singleSignatureTabsProps = {
          ...singleSignatureTabsProps,
          failedResources: filterResourceBaseOnRisksProperty(
            filteredResourcesOfSingleRisk,
            {
              status: 'fail',
            },
            currentRiskData.category
          ),
          passedResources: filterResourceBaseOnRisksProperty(
            filteredResourcesOfSingleRisk,
            {
              status: 'pass',
            },
            currentRiskData.category
          ),
          suppressResourceCount: filteredResourcesOfSingleRisk?.filter(v => v.suppress === true)
            .length,
        };
      }

      return (
        <div>
          <SingleSignatureHeader {...signatureHeaderProps} />
          <SingleSignatureDetail {...singleSignatureDetailProps} />
          <SingleSignatureTabs {...singleSignatureTabsProps} />
        </div>
      );
    }

    return <SignatureDrawerSkeleton />;
  }
}

export default SignatureDrawer;

const filterResourceBaseOnRisksProperty = (
  resourcesData = [],
  propertyOfFilter,
  currentSigCategory
) => {
  if (
    CNS_CATEGORIES.CVE?.toLowerCase() === currentSigCategory?.toLowerCase() ||
    CNS_CATEGORIES.MALWARE?.toLowerCase() === currentSigCategory?.toLowerCase()
  ) {
    return _.filter(resourcesData, propertyOfFilter);
  }

  return _.filter(resourcesData, val => {
    return _.some(val.risks, { ...propertyOfFilter });
  });
};
